module.exports = __webpack_public_path__ + "img/2.adf272ca.jpg";